import { render, staticRenderFns } from "./smd-loading-dots.vue?vue&type=template&id=5bb8e508&scoped=true&"
import script from "./smd-loading-dots.vue?vue&type=script&lang=js&"
export * from "./smd-loading-dots.vue?vue&type=script&lang=js&"
import style0 from "./smd-loading-dots.vue?vue&type=style&index=0&id=5bb8e508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8e508",
  null
  
)

export default component.exports